import * as React from 'react';

/** An inline loading spinner. */
export const InlineSpinner = () => (
  <span className="text-muted padding-left-10 padding-right-10">
    <i className="fa fa-spinner fa-spin" />
  </span>
);
